// 数字验证码——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `module/code/index${i + 1}`,
  name: `module/codeIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/code/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 数字验证码——主流程，开始
    ...MainRoutes
  ]
}
